import {useCallback, useState} from "react";
import {LOGIN_MODAL_CONTENT} from "../components/LoginModalContent";
import {analytics} from "../../../firebaseConfig";
import {logEvent} from "firebase/analytics";
import {login} from "../api/login";
import {useNavigate} from "react-router-dom";

export const useLogin = ({ email, password }) => {
  const [dialogContent, setDialogContent] = useState<LOGIN_MODAL_CONTENT | ''>('');

  const navigate = useNavigate();

  const submit = useCallback(async () => {
    setDialogContent(LOGIN_MODAL_CONTENT.LOADING);
    try {
      await login({ email, password })
      logEvent(analytics, 'loginSuccess', {email})
      navigate("/admin/caseManagement");
      setDialogContent('');
    } catch (err) {
      logEvent(analytics, 'loginFail', {email})
      setDialogContent(LOGIN_MODAL_CONTENT.ERROR);
    }
  }, [email, navigate, password])

  const confirmCompleted = () => setDialogContent('');

  return { dialogContent, submit, confirmCompleted }
}
